export const SETTINGS_CATEGORIES = {
    SAFETY_STATUS_CHECK: {
        label: "Safety Status Check",
        settings: [
            "SAFETY_STATUS_CHECK",
            "PREVIOUS_INSPECTION_VIEW",
            "EMAIL_REPORT",
            "EMAIL_PRIORITY",
            "STATUS_INSPECTION"
        ]
    },
    SERVICE_HISTORY: {
        label: "Service History",
        settings: [
            "SERVICE_HISTORY"
        ],
    },
    INTEGRATION: {
        label: "System",
        settings: ["INGEST_PRODUCT_EXCLUSION", "LICENSE_PLATE_EXCLUSION"]
    }
}